<template>
  <header class="card-header">
    <p class="card-header-title">
      <span class="icon"><i class="mdi mdi-ballot default"></i></span>
      {{ title }}
    </p>
    <router-link
      v-if="route"
      slot="right"
      :to="`${route}`"
      class="button is-info"
      style="margin-right: 1.5rem; margin-top: 1rem; margin-bottom: 1rem"
    >
      Adicionar
    </router-link>
  </header>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CardHeader',
    props: {
        title: {
            type: String,
            required: true
        },
        route: {
            type: String,
            required: false
        }
    },
})
</script>

<style></style>
